import { gql } from '@apollo/client';

export const CREATE_PATIENT_FEEDBACK = gql`
  mutation createPatientFeedback($marketId: Int!, $employerId: Int, $text: String!) {
    createPatientFeedback(marketId: $marketId, employerId: $employerId, text: $text) {
      success
      error
    }
  }
`;
